/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the state of a rollout target.
 */
export type RolloutTargetState = 'SCHEDULED' | 'EXECUTED' | 'FAILED' | 'CANCELED' | 'RESCHEDULED' | 'EXPIRED';

export const RolloutTargetState = {

    SCHEDULED: 'SCHEDULED' as RolloutTargetState,

    EXECUTED: 'EXECUTED' as RolloutTargetState,

    FAILED: 'FAILED' as RolloutTargetState,

    CANCELED: 'CANCELED' as RolloutTargetState,

    RESCHEDULED: 'RESCHEDULED' as RolloutTargetState,

    EXPIRED: 'EXPIRED' as RolloutTargetState
};

